import type { SendStatusResponse } from 'services/read-receipt'

/**
 * Read‑Receipt 상세 팝업이 열려있는 동안 emailId 별로 status 변경을 구독하기 위한
 * 모듈‑스코프 listener 저장소.
 *
 * - viewerExt.dispatchReadReceiptInfoToViewer 가 emailInfoMap 갱신 후 notifyReadReceipt 를 호출하면
 *   해당 emailId 를 구독 중인 모달이 setState 로 내용을 갱신한다.
 * - status === null 은 "갱신 시작 — 로딩" 신호.
 *   (refresh 중에는 dispatch 가 statusData=null 을 1회 produce 한 뒤 실제 결과를 다시 produce 함.)
 */

export type ReadReceiptListener = (status: SendStatusResponse | null) => void

const listenersByEmailId = new Map<string, Set<ReadReceiptListener>>()

export function subscribeReadReceipt(emailId: string, listener: ReadReceiptListener): () => void {
  let set = listenersByEmailId.get(emailId)
  if (set == null) {
    set = new Set()
    listenersByEmailId.set(emailId, set)
  }
  set.add(listener)

  return () => {
    const cur = listenersByEmailId.get(emailId)
    if (cur == null) return
    cur.delete(listener)
    if (cur.size === 0) {
      listenersByEmailId.delete(emailId)
    }
  }
}

export function notifyReadReceipt(emailId: string, status: SendStatusResponse | null): void {
  const set = listenersByEmailId.get(emailId)
  if (set == null || set.size === 0) return
  // listener 콜백 안에서 unsubscribe 해도 안전하도록 snapshot 순회.
  Array.from(set).forEach((listener) => {
    try {
      listener(status)
    } catch (err) {
      console.error('[readReceiptListenerStore] listener threw', err)
    }
  })
}

/** 테스트 전용 — 모듈 스코프 상태 초기화. */
export function __resetReadReceiptListenersForTest(): void {
  listenersByEmailId.clear()
}
